import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["loader"]
  static values = {
    url: String,
    page: Number,
    totalPages: Number
  }

  connect() {
    this.setupObserver()
    if (this.hasLoaderTarget) {
      this.intersectObserver.observe(this.loaderTarget)
    }
  }

  setupObserver() {
    if (this.intersectObserver) {
      this.intersectObserver.disconnect()
    }

    const scrollRoot = this.element.closest("[data-infinite-scroll-root]")
    const useScrollRoot = scrollRoot && window.matchMedia("(min-width: 1024px)").matches

    this.intersectObserver = new IntersectionObserver(entries => {
      this.handleIntersect(entries)
    }, {
      root: useScrollRoot ? scrollRoot : null,
      rootMargin: useScrollRoot ? "400px" : "800px",
      threshold: 0
    })
  }

  loaderTargetConnected(element) {
    if (this.intersectObserver) {
      this.intersectObserver.observe(element)
    }
  }

  loaderTargetDisconnected(element) {
    if (this.intersectObserver) {
      this.intersectObserver.unobserve(element)
    }
  }

  disconnect() {
    if (this.intersectObserver) {
      this.intersectObserver.disconnect()
    }
  }

  handleIntersect(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting && !this.loading && this.pageValue < this.totalPagesValue) {
        this.loadMore()
      }
    })
  }

  loadMore() {
    if (this.loading || this.pageValue >= this.totalPagesValue) return
    this.loading = true

    const nextPage = this.pageValue + 1

    const url = new URL(this.urlValue, window.location.origin)
    const currentParams = new URLSearchParams(window.location.search)

    currentParams.forEach((value, key) => {
      if (key !== "page") {
        url.searchParams.set(key, value)
      }
    })
    url.searchParams.set("page", nextPage)

    fetch(url.toString(), {
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
    .then(response => {
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)
      return response.text()
    })
    .then(html => {
      if (html.trim().length > 0) {
        Turbo.renderStreamMessage(html)
        this.pageValue = nextPage
      } else {
        this.totalPagesValue = this.pageValue
      }
    })
    .catch(error => {
      console.error("InfiniteScroll: Error during fetch:", error)
    })
    .finally(() => {
      setTimeout(() => {
        this.loading = false
      }, 400)
    })
  }
}
